export default 'M6 19.65V4h12v15.65l-6-3.67zm6-.15 5.96 3.64a2 2 0 0 0 3.04-1.7V4a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v17.43a2 2 0 0 0 3.04 1.71z';